<template>
  <div class="card">
    <Loader v-if="loader" />

    <div class="grid mb-4">
      <div class="col-12 lg:col-6 flex align-items-end">
        <div class="flex-1 mr-2">
          <h6 class="ml-2">Mese/Anno</h6>
          <Calendar
            v-model="selectedMonthYear"
            :showIcon="true"
            view="month"
            dateFormat="mm/yy"
            class="inputfield w-full"
          />
        </div>
        <div class="mr-3 flex align-items-center">
          <Checkbox
            v-model="calcoloMeseSelezionato"
            :binary="true"
            inputId="calcolo-mese-selezionato"
            class="mr-2"
          />
          <label for="calcolo-mese-selezionato" class="text-sm">
            Calcolo su mese selezionato
          </label>
        </div>
        <Button
          label="Cerca"
          icon="pi pi-search"
          class="p-button-ml"
          @click="loadAgentsSummary"
        />
      </div>
    </div>

    <div v-if="agentsSummary.energy && agentsSummary.energy.length" class="mb-5">
      <h5 class="mb-3">Riepilogo insoluti per agente - POWER</h5>

      <div class="mb-2">
        <span class="p-input-icon-left w-full md:w-20rem">
          <i class="pi pi-search" />
          <InputText
            v-model="agentSearch"
            class="w-full"
            placeholder="Filtra per nome agente..."
          />
        </span>
      </div>

      <DataTable :value="filteredAgentsEnergy" responsiveLayout="scroll">
        <Column header="Agente" :sortable="true">
          <template #body="{ data }">
          <span
              class="text-primary cursor-pointer font-semibold"
              @click="openRappresentanteDetails(data.agente, 'energy')"
          >
              {{ data.agente }}
          </span>
          </template>
        </Column>
        <Column field="quantiPod" header="N. POD" :sortable="true" bodyClass="text-right" />
        <Column
          field="consumoAnnuo"
          header="Consumo annuo"
          :sortable="true"
          bodyClass="text-right"
        >
          <template #body="{ data }">
            {{ formatNumber(data.consumoAnnuo) }}
          </template>
        </Column>
        <Column
          field="saldoAttiviVariabile"
          :header="saldoAttiviHeader"
          :sortable="true"
          bodyClass="text-right"
        >
          <template #body="{ data }">
            {{ formatCurrency(data.saldoAttiviVariabile) }}
          </template>
        </Column>
        <Column
          field="saldoAttivi2025"
          :header="saldoAttivi2025Header"
          :sortable="true"
          bodyClass="text-right"
        >
          <template #body="{ data }">
            {{ formatCurrency(data.saldoAttivi2025) }}
          </template>
        </Column>
        <Column
          field="saldoNONAttiviVariabile"
          :header="saldoNonAttiviHeader"
          :sortable="true"
          bodyClass="text-right"
        >
          <template #body="{ data }">
            {{ formatCurrency(data.saldoNONAttiviVariabile) }}
          </template>
        </Column>
        <Column
          field="saldoAttivi"
          header="Saldo attivi tot."
          :sortable="true"
          bodyClass="text-right"
        >
          <template #body="{ data }">
            {{ formatCurrency(data.saldoAttivi) }}
          </template>
        </Column>
       
        <Column
          field="fatturatoUltimoMese"
          header="Tot.Fatture (ultimo mese)"
          :sortable="true"
          bodyClass="text-right"
        >
          <template #body="{ data }">
            {{ formatCurrency(data.fatturatoUltimoMese) }}
          </template>
        </Column>
      </DataTable>
                    </div>

    <div v-if="agentsSummary.gas && agentsSummary.gas.length" class="mb-5">
      <h5 class="mb-3">Riepilogo insoluti per agente - GAS</h5>

      <DataTable :value="filteredAgentsGas" responsiveLayout="scroll">
        <Column header="Agente" :sortable="true">
          <template #body="{ data }">
            <span
              class="text-primary cursor-pointer font-semibold"
              @click="openRappresentanteDetails(data.agente, 'gas')"
            >
              {{ data.agente }}
            </span>
          </template>
        </Column>
        <Column field="quantiPdr" header="N. PDR" :sortable="true" bodyClass="text-right" />
        <Column
          field="consumoAnnuo"
          header="Consumo annuo"
          :sortable="true"
          bodyClass="text-right"
        >
          <template #body="{ data }">
            {{ formatNumber(data.consumoAnnuo) }}
          </template>
        </Column>
        <Column
          field="saldoAttiviVariabile"
          :header="saldoAttiviHeader"
          :sortable="true"
          bodyClass="text-right"
        >
          <template #body="{ data }">
            {{ formatCurrency(data.saldoAttiviVariabile) }}
          </template>
        </Column>
        <Column
          field="saldoAttivi2025"
          :header="saldoAttivi2025Header"
          :sortable="true"
          bodyClass="text-right"
        >
          <template #body="{ data }">
            {{ formatCurrency(data.saldoAttivi2025) }}
          </template>
        </Column>
        <Column
          field="saldoNONAttiviVariabile"
          :header="saldoNonAttiviHeader"
          :sortable="true"
          bodyClass="text-right"
        >
          <template #body="{ data }">
            {{ formatCurrency(data.saldoNONAttiviVariabile) }}
          </template>
        </Column>
        <Column
          field="saldoAttivi"
          header="Saldo attivi tot."
          :sortable="true"
          bodyClass="text-right"
        >
          <template #body="{ data }">
            {{ formatCurrency(data.saldoAttivi) }}
          </template>
        </Column>
        <Column
          field="fatturatoUltimoMese"
          header="Tot.Fatture (ultimo mese)"
          :sortable="true"
          bodyClass="text-right"
        >
          <template #body="{ data }">
            {{ formatCurrency(data.fatturatoUltimoMese) }}
          </template>
        </Column>
      </DataTable>
                </div>

    <div v-if="agentsSummary.combined && agentsSummary.combined.length" class="mb-5">
      <h5 class="mb-3">Riepilogo insoluti per agente - LUCE E GAS</h5>
      <DataTable :value="filteredAgentsCombined" responsiveLayout="scroll">
        <Column header="Agente" :sortable="true">
          <template #body="{ data }">
            <span
              class="text-primary cursor-pointer font-semibold"
              @click="openRappresentanteDetails(data.agente, 'combined')"
            >
              {{ data.agente }}
            </span>
          </template>
        </Column>
        <Column field="quantiPuntiFornitura" header="N. Punti Fornitura" :sortable="true" bodyClass="text-right" />
        <Column
          field="consumoAnnuo"
          header="Consumo annuo"
          :sortable="true"
          bodyClass="text-right"
        >
          <template #body="{ data }">
            {{ formatNumber(data.consumoAnnuo) }}
          </template>
        </Column>
        <Column
          field="saldoAttiviVariabile"
          :header="saldoAttiviHeader"
          :sortable="true"
          bodyClass="text-right"
        >
          <template #body="{ data }">
            {{ formatCurrency(data.saldoAttiviVariabile) }}
          </template>
        </Column>
        <Column
          field="saldoAttivi2025"
          :header="saldoAttivi2025Header"
          :sortable="true"
          bodyClass="text-right"
        >
          <template #body="{ data }">
            {{ formatCurrency(data.saldoAttivi2025) }}
          </template>
        </Column>
        <Column
          field="saldoNONAttiviVariabile"
          :header="saldoNonAttiviHeader"
          :sortable="true"
          bodyClass="text-right"
        >
          <template #body="{ data }">
            {{ formatCurrency(data.saldoNONAttiviVariabile) }}
          </template>
        </Column>
        <Column
          field="saldoAttivi"
          header="Saldo attivi tot."
          :sortable="true"
          bodyClass="text-right"
        >
          <template #body="{ data }">
            {{ formatCurrency(data.saldoAttivi) }}
          </template>
        </Column>
        <Column
          field="fatturatoUltimoMese"
          header="Tot.Fatture (ultimo mese)"
          :sortable="true"
          bodyClass="text-right"
        >
          <template #body="{ data }">
            {{ formatCurrency(data.fatturatoUltimoMese) }}
          </template>
        </Column>
      </DataTable>
                </div>

    <Dialog
      v-model:visible="detailsDialog"
      :style="{ width: '80vw' }"
      header="Dettaglio insoluti per rappresentante"
      :modal="true"
    >
      <div v-if="rappresentantiSummary.energy && rappresentantiSummary.energy.length" class="mb-4">
        <h5 class="mb-3">
          Riepilogo insoluti POWER - {{ currentAgentName }}
        </h5>

        <div class="mb-2">
          <span class="p-input-icon-left w-full md:w-20rem">
            <i class="pi pi-search" />
            <InputText
              v-model="rappSearch"
              class="w-full"
              placeholder="Filtra per nome rappresentante..."
            />
          </span>
        </div>

        <DataTable :value="filteredRappEnergy" responsiveLayout="scroll">
          <Column field="rappresentante" header="Rappresentante" :sortable="true">
            <template #body="{ data }">
              <span
                class="text-primary cursor-pointer font-semibold"
                @click="openIncallTabForRappresentante(data.rappresentante)"
              >
                {{ data.rappresentante }}
              </span>
            </template>
          </Column>
          <Column
            field="quantiPod"
            header="N. Pdp"
            :sortable="true"
            bodyClass="text-right"
          />
          <Column
            field="consumoAnnuo"
            header="Consumo annuo"
            :sortable="true"
            bodyClass="text-right"
          >
            <template #body="{ data }">
              {{ formatNumber(data.consumoAnnuo) }}
            </template>
          </Column>
          <Column
            field="saldoAttiviVariabile"
            :header="saldoAttiviHeader"
            :sortable="true"
            bodyClass="text-right"
          >
            <template #body="{ data }">
              {{ formatCurrency(data.saldoAttiviVariabile) }}
            </template>
          </Column>
          <Column
            field="saldoAttivi2025"
            :header="saldoAttivi2025Header"
            :sortable="true"
            bodyClass="text-right"
          >
            <template #body="{ data }">
              {{ formatCurrency(data.saldoAttivi2025) }}
            </template>
          </Column>
          <Column
            field="saldoNONAttiviVariabile"
            :header="saldoNonAttiviHeader"
            :sortable="true"
            bodyClass="text-right"
          >
            <template #body="{ data }">
              {{ formatCurrency(data.saldoNONAttiviVariabile) }}
            </template>
          </Column>
          <Column
            field="saldoAttivi"
            header="Saldo attivi tot."
            :sortable="true"
            bodyClass="text-right"
          >
            <template #body="{ data }">
              {{ formatCurrency(data.saldoAttivi) }}
            </template>
          </Column>
          <Column
            field="fatturatoUltimoMese"
            header="Tot.Fatture (ultimo mese)"
            :sortable="true"
            bodyClass="text-right"
          >
            <template #body="{ data }">
              {{ formatCurrency(data.fatturatoUltimoMese) }}
            </template>
          </Column>
      </DataTable>
    </div>

      <div v-if="rappresentantiSummary.gas && rappresentantiSummary.gas.length" class="mb-4">
        <h5 class="mb-3">
          Riepilogo insoluti GAS - {{ currentAgentName }}
        </h5>

        <div class="mb-2">
          <span class="p-input-icon-left w-full md:w-20rem">
            <i class="pi pi-search" />
            <InputText
              v-model="rappSearch"
              class="w-full"
              placeholder="Filtra per nome rappresentante..."
            />
          </span>
        </div>

        <DataTable :value="filteredRappGas" responsiveLayout="scroll">
          <Column field="rappresentante" header="Rappresentante" :sortable="true">
            <template #body="{ data }">
              <span
                class="text-primary cursor-pointer font-semibold"
                @click="openIncallTabForRappresentante(data.rappresentante)"
              >
                {{ data.rappresentante }}
              </span>
            </template>
          </Column>
          <Column
            field="quantiPdr"
            header="N. Pdr"
            :sortable="true"
            bodyClass="text-right"
          />
          <Column
            field="consumoAnnuo"
            header="Consumo annuo"
            :sortable="true"
            bodyClass="text-right"
          >
            <template #body="{ data }">
              {{ formatNumber(data.consumoAnnuo) }}
            </template>
          </Column>
          <Column
            field="saldoAttiviVariabile"
            :header="saldoAttiviHeader"
            :sortable="true"
            bodyClass="text-right"
          >
            <template #body="{ data }">
              {{ formatCurrency(data.saldoAttiviVariabile) }}
            </template>
          </Column>
          <Column
            field="saldoAttivi2025"
            :header="saldoAttivi2025Header"
            :sortable="true"
            bodyClass="text-right"
          >
            <template #body="{ data }">
              {{ formatCurrency(data.saldoAttivi2025) }}
            </template>
          </Column>
          <Column
            field="saldoNONAttiviVariabile"
            :header="saldoNonAttiviHeader"
            :sortable="true"
            bodyClass="text-right"
          >
            <template #body="{ data }">
              {{ formatCurrency(data.saldoNONAttiviVariabile) }}
            </template>
          </Column>
          <Column
            field="saldoAttivi"
            header="Saldo attivi tot."
            :sortable="true"
            bodyClass="text-right"
          >
            <template #body="{ data }">
              {{ formatCurrency(data.saldoAttivi) }}
            </template>
          </Column>
          <Column
            field="fatturatoUltimoMese"
            header="Tot.Fatture (ultimo mese)"
            :sortable="true"
            bodyClass="text-right"
          >
            <template #body="{ data }">
              {{ formatCurrency(data.fatturatoUltimoMese) }}
            </template>
          </Column>
        </DataTable>
      </div>

      <div v-if="rappresentantiSummary.combined && rappresentantiSummary.combined.length">
        <h5 class="mb-3">
          Riepilogo insoluti LUCE E GAS - {{ currentAgentName }}
        </h5>

        <div class="mb-2">
          <span class="p-input-icon-left w-full md:w-20rem">
            <i class="pi pi-search" />
            <InputText
              v-model="rappSearch"
              class="w-full"
              placeholder="Filtra per nome rappresentante..."
            />
          </span>
        </div>

        <DataTable :value="filteredRappCombined" responsiveLayout="scroll">
          <Column field="rappresentante" header="Rappresentante" :sortable="true">
            <template #body="{ data }">
              <span
                class="text-primary cursor-pointer font-semibold"
                @click="openIncallTabForRappresentante(data.rappresentante)"
              >
                {{ data.rappresentante }}
              </span>
            </template>
          </Column>
          <Column
            field="quantiPuntiFornitura"
            header="N. Punti Fornitura"
            :sortable="true"
            bodyClass="text-right"
          />
          <Column
            field="consumoAnnuo"
            header="Consumo annuo"
            :sortable="true"
            bodyClass="text-right"
          >
            <template #body="{ data }">
              {{ formatNumber(data.consumoAnnuo) }}
            </template>
          </Column>
          <Column
            field="saldoAttiviVariabile"
            :header="saldoAttiviHeader"
            :sortable="true"
            bodyClass="text-right"
          >
            <template #body="{ data }">
              {{ formatCurrency(data.saldoAttiviVariabile) }}
            </template>
          </Column>
          <Column
            field="saldoAttivi2025"
            :header="saldoAttivi2025Header"
            :sortable="true"
            bodyClass="text-right"
          >
            <template #body="{ data }">
              {{ formatCurrency(data.saldoAttivi2025) }}
            </template>
          </Column>
          <Column
            field="saldoNONAttiviVariabile"
            :header="saldoNonAttiviHeader"
            :sortable="true"
            bodyClass="text-right"
          >
            <template #body="{ data }">
              {{ formatCurrency(data.saldoNONAttiviVariabile) }}
            </template>
          </Column>
          <Column
            field="saldoAttivi"
            header="Saldo attivi tot."
            :sortable="true"
            bodyClass="text-right"
          >
            <template #body="{ data }">
              {{ formatCurrency(data.saldoAttivi) }}
            </template>
          </Column>
          <Column
            field="fatturatoUltimoMese"
            header="Tot.Fatture (ultimo mese)"
            :sortable="true"
            bodyClass="text-right"
          >
            <template #body="{ data }">
              {{ formatCurrency(data.fatturatoUltimoMese) }}
            </template>
          </Column>
        </DataTable>
      </div>

    <template #footer>
        <Button label="Chiudi" icon="pi pi-times" class="p-button-text" @click="detailsDialog = false" />
    </template>
  </Dialog>
  </div>
</template>

<script>
import moment from 'moment'
import Utility from '@/services/ask-management/utility-service'
import Service from '@/services/ask-pratiche/pratiche-service'
import { ref, onMounted, getCurrentInstance, computed } from 'vue'
import { useRouter } from 'vue-router'
import Loader from '@/components/Loader.vue'
import InputText from 'primevue/inputtext'
import Checkbox from 'primevue/checkbox'
import { useToast } from 'primevue/usetoast'

export default {
    components: {
      Loader,
      InputText,
      Checkbox,
    },
    props: {
      hideSearch: {
        type: Boolean,
      default: false,
      },
      rappresentanteId: {
        type: [String, Number],
      default: null,
      },
      anni: {
        type: Array,
      default: () => [],
    },
    },
    setup() {
    const toast = useToast()
    const router = useRouter()
    const loader = ref(false)
    const selectedMonthYear = ref(null)
    const calcoloMeseSelezionato = ref(false)
    const agentsSummary = ref({ energy: [], gas: [], combined: [] })
    const rappresentantiSummary = ref({ energy: [], gas: [], combined: [] })
    const saldoAttiviHeader = ref('Saldo attivi ≤ data scad.')
    const saldoNonAttiviHeader = ref('Saldo non attivi ≤ data scad.')
    const saldoAttivi2025Header = ref('Saldo attivi 2025 ≤ data scad.')
    const agentsList = ref([])
    const currentAgentName = ref('')
    const detailsDialog = ref(false)
    const agentSearch = ref('')
    const rappSearch = ref('')

    const self = getCurrentInstance()
      self.$eventBus = self.appContext.config.globalProperties.$eventBus
      self.$http = self.appContext.config.globalProperties.$http

      const service = new Service(self.$http, self.$eventBus)
      const utility = new Utility(self.$http, self.$eventBus)

    const loadAgents = async () => {
      try {
        loader.value = true
        const res = await utility.getAgenti(1)
        agentsList.value = res.items || []
      } catch (e) {
        // gestito da eventBus
      } finally {
          loader.value = false
      }
    }

    onMounted(() => {
      loadAgents()
    })

    const getYearMonth = () => {
      if (!selectedMonthYear.value || !moment(selectedMonthYear.value).isValid()) {
        toast.add({
          severity: 'warn',
          summary: 'Attenzione',
          detail: 'Seleziona un mese/anno',
          life: 4000,
        })
        return null
      }
      const m = moment(selectedMonthYear.value).startOf('month')

      if (calcoloMeseSelezionato.value) {
        const endOfSelected = m.clone().endOf('month')
        const label = endOfSelected.isValid() ? endOfSelected.format('DD/MM/YYYY') : ''
        saldoAttiviHeader.value = `Saldo attivi ≤ data scad. al ${label} con data emissione dal 2024`
        saldoNonAttiviHeader.value = `Saldo non attivi ≤ data scad. al ${label} con data emissione dal 2024`
        saldoAttivi2025Header.value = `Saldo attivi ≤ data scad. al ${label} con data emissione dal 2025`
      } else {
        const twoBeforeEnd = m.clone().subtract(2, 'months').endOf('month')
        const label = twoBeforeEnd.isValid() ? twoBeforeEnd.format('DD/MM/YYYY') : ''
        saldoAttiviHeader.value = `Saldo attivi ≤ data scad. al ${label} con data emissione dal 2024`
        saldoNonAttiviHeader.value = `Saldo non attivi ≤ data scad. al ${label} con data emissione dal 2024`
        saldoAttivi2025Header.value = `Saldo attivi ≤ data scad. al ${label} con data emissione dal 2025`
      }
      return {
        year: m.year(),
        month: m.month() + 1,
        calcoloMeseSelezionato: calcoloMeseSelezionato.value ? 1 : 0,
      }
    }

    const loadAgentsSummary = async () => {
      const ym = getYearMonth()
      if (!ym) return

      agentsSummary.value = { energy: [], gas: [], combined: [] }
      rappresentantiSummary.value = { energy: [], gas: [], combined: [] }
      detailsDialog.value = false

      loader.value = true
      try {
        const { items } = await service.getSummaryInsolutiAgenti(
          ym.year,
          ym.month,
          ym.calcoloMeseSelezionato
        )
        agentsSummary.value = items || { energy: [], gas: [], combined: [] }
      } catch (e) {
        // gestito da eventBus
      } finally {
            loader.value = false
      }
    }

    const openRappresentanteDetails = async (agenteNome, tipo) => {
      const ym = getYearMonth()
      if (!ym) return

      const agente = agentsList.value.find(a => a.name === agenteNome)
      if (!agente) {
        toast.add({
          severity: 'warn',
          summary: 'Attenzione',
          detail: 'Impossibile trovare il codice agente per ' + agenteNome,
          life: 4000,
        })
        return
      }

      rappresentantiSummary.value = { energy: [], gas: [], combined: [] }
      rappSearch.value = ''
        loader.value = true
      try {
        const { items } = await service.getSummaryInsolutiRappresentanti(
          agente.id,
          ym.year,
          ym.month,
          ym.calcoloMeseSelezionato
        )
        if (tipo === 'energy') {
          rappresentantiSummary.value = {
            energy: (items && items.energy) || [],
            gas: [],
            combined: [],
          }
        } else if (tipo === 'gas') {
          rappresentantiSummary.value = {
            energy: [],
            gas: (items && items.gas) || [],
            combined: [],
          }
        } else if (tipo === 'combined') {
          rappresentantiSummary.value = {
            energy: [],
            gas: [],
            combined: (items && items.combined) || [],
          }
        } else {
          rappresentantiSummary.value = items || { energy: [], gas: [], combined: [] }
        }
        currentAgentName.value = agente.name
        detailsDialog.value = true
      } catch (e) {
        // gestito da eventBus
      } finally {
          loader.value = false            
      }
    }

    const openIncallTabForRappresentante = (rappresentanteNome) => {
      const route = router.resolve({
        path: '/in-call',
        query: {
          search_type: 'rappresentante',
          q: rappresentanteNome || '',
        },
      })
      window.open(route.href, '_blank')
    }

    const formatCurrency = value => {
      const num = Number(value)
      if (!isFinite(num)) {
        return (0).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' })
      }
      return num.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' })
    }

    const formatNumber = value => {
      const num = Number(value)
      if (!isFinite(num)) {
        return 0
      }
      return num.toLocaleString('it-IT')
    }

    const filteredAgentsEnergy = computed(() => {
      if (!agentSearch.value) {
        return agentsSummary.value.energy || []
      }
      const term = agentSearch.value.toUpperCase()
      return (agentsSummary.value.energy || []).filter(item =>
        String(item.agente || '').toUpperCase().includes(term)
      )
    })

    const filteredAgentsGas = computed(() => {
      if (!agentSearch.value) {
        return agentsSummary.value.gas || []
      }
      const term = agentSearch.value.toUpperCase()
      return (agentsSummary.value.gas || []).filter(item =>
        String(item.agente || '').toUpperCase().includes(term)
      )
    })

    const filteredRappEnergy = computed(() => {
      if (!rappSearch.value) {
        return rappresentantiSummary.value.energy || []
      }
      const term = rappSearch.value.toUpperCase()
      return (rappresentantiSummary.value.energy || []).filter(item =>
        String(item.rappresentante || '').toUpperCase().includes(term)
      )
    })

    const filteredRappGas = computed(() => {
      if (!rappSearch.value) {
        return rappresentantiSummary.value.gas || []
      }
      const term = rappSearch.value.toUpperCase()
      return (rappresentantiSummary.value.gas || []).filter(item =>
        String(item.rappresentante || '').toUpperCase().includes(term)
      )
    })

    const filteredAgentsCombined = computed(() => {
      if (!agentSearch.value) {
        return agentsSummary.value.combined || []
      }
      const term = agentSearch.value.toUpperCase()
      return (agentsSummary.value.combined || []).filter(item =>
        String(item.agente || '').toUpperCase().includes(term)
      )
    })

    const filteredRappCombined = computed(() => {
      if (!rappSearch.value) {
        return rappresentantiSummary.value.combined || []
      }
      const term = rappSearch.value.toUpperCase()
      return (rappresentantiSummary.value.combined || []).filter(item =>
        String(item.rappresentante || '').toUpperCase().includes(term)
      )
    })

    return {
      loader,
      selectedMonthYear,
      calcoloMeseSelezionato,
      agentsSummary,
      rappresentantiSummary,
      loadAgentsSummary,
      openRappresentanteDetails,
      formatCurrency,
      formatNumber,
      detailsDialog,
      currentAgentName,
      saldoAttiviHeader,
      saldoNonAttiviHeader,
      saldoAttivi2025Header,
      agentSearch,
      rappSearch,
      filteredAgentsEnergy,
      filteredAgentsGas,
      filteredAgentsCombined,
      filteredRappEnergy,
      filteredRappGas,
      filteredRappCombined,
      openIncallTabForRappresentante,
    }
  },
}
</script>


